import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faRubleSign } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import { BootstrapVue } from "bootstrap-vue";
import VueDragula from "vue-dragula";
import { setLicenseKey } from "@grapecity/wijmo";
import store from "./store";
import router from "./router";
import App from "./app";
import "@grapecity/wijmo.cultures/wijmo.culture.ru";
import smoothscroll from 'smoothscroll-polyfill';

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "normalize.css/normalize.css";
import "vue-select/dist/vue-select.css";
import "dragula/dist/dragula.min.css";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

import "./assets/fonts/firasans/firasans.css";
import "./assets/styles/main.scss";

import "@/plugins/vee-validate";

Vue.use(PerfectScrollbar);
Vue.use(BootstrapVue);
Vue.use(VueDragula);

library.add(faRubleSign);

Vue.component("font-awesome-icon", FontAwesomeIcon);

setLicenseKey("rkozlov95@mail.ru,E961578766511658#B0PmyjIyNHZisnOiwmbBJye0ICRiwiI34zZwEnQ5g7Y7kDVXZDejVEdo9kY4QzKUFFTahDTTpEexkEaMd7bGxUYqVlY5ZkaS94SxEGNMZ6ToxUb7tmaVFFOUF6QRhGSxFlNlRzUilUWNBFcyMzSEtCar9WZzc5d7hUMu3kV6VHZX5WQvUlTyJkSv2WUPNXYkp5TvJ4KttiZldTYZNXUvIFcNhzTJhkNrtWWrcjeHFjZXJ6aMVma5pXRpdFeDhWY59Ga0ZGb0lUNZJnU6NWa7BFbmdjM8Z6Z6pFeth5S7lWNEtmYvQDMXBjarV4UyI5dXVGTsBzRMtyNqBlQj5kZyo5YQJjZlJEbIFWcMVkN9hjYrF7RnBTY9h6cnZkcJRje0RTajFjcEF4L6BFaXlldiZXO8sEbXhlW4ITMol4NlFETBRHWqZlUaxEUxMnazJkWBBlSzoVdnNVVwUnQyg7dPRnT64WR7EERh56L5pHWutkI0IyUiwiIyYTO8EkQzcjI0ICSiwyMyIzN4kjNzMTM0IicfJye&Qf35VfikEMyIlI0IyQiwiIu3Waz9WZ4hXRgACdlVGaThXZsZEIv5mapdlI0IiTisHL3JSNJ9UUiojIDJCLi86bpNnblRHeFBCIyV6dllmV4J7bwVmUg2Wbql6ViojIOJyes4nILdDOIJiOiMkIsIibvl6cuVGd8VEIgc7bSlGdsVXTg2Wbql6ViojIOJyes4nI4YkNEJiOiMkIsIibvl6cuVGd8VEIgAVQM3EIg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyes4nIVhzNBJiOiMkIsIibvl6cuVGd8VEIgQnchh6QsFWaj9WYulmRg2Wbql6ViojIOJyebpjIkJHUiwiI6ADNxkDMgMDM5ATMyAjMiojI4J7QiwiIyAjNwEjMwIjI0ICc8VkIsISdy9CbpFWbAVTO63Gb036ayJiOiEmTDJCLlVnc4pjIsZXRiwiI8UjNxETN6YzN8cTNxYTOiojIklkIs4XXbpjInxmZiwiIyYXMyAjMiojIyVmdiwSXzzW");

new Vue({
    render: h => h(App),
    store,
    router,
}).$mount("#app");

smoothscroll.polyfill();